<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-section">
      <h3>AI Optima</h3>
      <p>AI Search & Marketing Intelligence Platform</p>
    </div>
    
    <div class="footer-section">
      <h4>Legal</h4>
      <ul class="footer-links">
        <li><a routerLink="/">Home</a></li>
        <li><a routerLink="/about">About Us</a></li>
        <li><a routerLink="/terms">Terms and Conditions</a></li>
        <li><a routerLink="/privacy">Privacy Policy</a></li>
        <li><a routerLink="/cookie-policy">Cookie Policy</a></li>
        <li *ngIf="isAdmin()"><a routerLink="/pricing">Pricing</a></li>
      </ul>
    </div>
  </div>
  
  <div class="footer-bottom">
    <p>&copy; {{ currentYear }} AIOptima. All rights reserved.</p>
  </div>
</footer>
